import moment from "moment";

const SUPPORTED_DATE_FORMATS = ["DD-MMM-YYYY", "YYYY-MM-DD", "DD-MM-YYYY", "DD/MM/YYYY"];

const parseDate = (dateString) => {
  if (!dateString) {
    return moment.invalid();
  }
  const parsed = moment(dateString, SUPPORTED_DATE_FORMATS);
  if (parsed.isValid()) {
    return parsed;
  }
  return moment(dateString);
};

export const validateExpiryStatus = (expiryDate) => {
  if (!expiryDate || expiryDate === "N/A" || expiryDate === "-") {
    return { status: "Unknown", color: "#8790A1", bgColor: "#F5F5F5" };
  }

  try {
    const parsedDate = parseDate(expiryDate);

    if (!parsedDate.isValid()) {
      return { status: "Invalid Date", color: "#FF4444", bgColor: "#FFE5E5" };
    }

    const today = moment();
    const daysUntilExpiry = parsedDate.diff(today, "days");

    if (daysUntilExpiry < 0) {
      return { status: "Expired", color: "#FF4444", bgColor: "#FFE5E5" };
    } else if (daysUntilExpiry <= 30) {
      return { status: "Expiring Soon", color: "#FF8C00", bgColor: "#FFF4E5" };
    } else {
      return { status: "Active", color: "#2C8C53", bgColor: "#E8F5E9" };
    }
  } catch (error) {
    console.error("Error parsing date:", error);
    return { status: "Error", color: "#FF4444", bgColor: "#FFE5E5" };
  }
};

export const checkIfExpired = (dateString) => {
  if (!dateString || dateString === "N/A" || dateString === "-") {
    return false;
  }
  const expiryDate = parseDate(dateString);
  if (!expiryDate.isValid()) {
    return false;
  }
  const today = moment();
  return expiryDate.isBefore(today, "day");
};
